import { render, staticRenderFns } from "./GroupDiscountList.vue?vue&type=template&id=e326e1fe"
import script from "./GroupDiscountList.vue?vue&type=script&lang=js"
export * from "./GroupDiscountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports